export const CLOSE_MOBILE_HEADER_MENU_EVENT = 'CLOSE_MOBILE_HEADER_MENU_EVENT'
